<template>
  <div @click.stop>
    <button @click="show = true" class="hover:underline text-indigo-500">
      {{ facebookCampaign.name }}
    </button>

    <Portal v-if="show" to="app-dialog">
      <OverviewModal :facebook-campaign-id="facebookCampaign.id" @close="show = false" />
    </Portal>
  </div>
</template>

<script>
import OverviewModal from 'Components/FacebookCampaigns/OverviewModal.vue';

export default {
  components: {
    OverviewModal,
  },
  props: {
    facebookCampaign: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>
